import apiConfig from '../config/api'
import { apiRequestorHelper } from '../helpers'

export default {
  system: (templateId) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/form/getDataSourcesSystem/'+templateId,
      method: 'post'
    })
  },
  catalogo: () => {
    return apiRequestorHelper({
      url: apiConfig.url + '/form/getDataSourcesCatalogo',
      method: 'post'
    })
  },
  form: (formId) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/form/getDataSourcesClient/'+formId,
      method: 'post'
    })
  }
}
